export enum CarType {
    USED = 'used',
    NEW = 'new',
}
